import {ResultComponent} from "../components/result/ResultComponent";
import {useParams} from "react-router-dom";
import {RouteParam} from "../types/types";
import {CompleteViewModel} from "../viewmodel/complete/CompleteViewModel";
import {useStepCheck} from "../hooks/stepcheck/useStepCheck";
import {useEffect} from "react";

const CompletePage: React.FC = () => {
    const { verificationId } = useParams<RouteParam>();
    const { evaluateUrl } = useStepCheck(verificationId)

    useEffect(() => {
        evaluateUrl()
    }, [evaluateUrl])

    const { result, name, failureMessage } = CompleteViewModel(verificationId)

    return (
        <ResultComponent result={result} name={name} failureMessage={failureMessage}/>
    )
}

export default CompletePage;